import React from "react";
import { Container, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Link from "next/link";
import Image from "next/image";
import CloseIcon from "@mui/icons-material/Close";
import BigCapLogo from "@icons/BigCapLogo";
import { useRouter } from "next/router";

/**
 * StepLayout - generic layout wrapper for a discovery step screen.
 * Reusable across roles and steps.
 */
export default function StepLayout({
  title,
  subtitle,
  children,
  footer,
  onBack,
}) {
  const router = useRouter();
  const onBackToWordPressPage = () => {
    router.push(process.env.NEXT_PUBLIC_WORD_PRESS_URL);
  };
  return (
    <div className="relative bg-slate-50 min-h-screen flex flex-col">
      {/* Top bar */}
      <div className="relative flex items-center justify-between p-3 md:p-4 border-b border-gray-300 px-4 md:px-12 shrink-0">
        <button
          onClick={onBack}
          className={`p-2 gap-2 flex items-center hover:bg-gray-100 rounded-full`}
        >
          <ArrowBackIcon />
          <span className="hidden sm:inline">Back</span>
        </button>
        <div className="absolute left-1/2 transform -translate-x-1/2 w-max">
          <Link href="/">
            <Image
              alt="College Aid Pro"
              priority={true}
              src="/images/cap_main_logo_blue.png"
              width={250}
              height={250}
              sizes="(max-width: 640px) 128px, 250px"
              className="cursor-pointer h-8 sm:h-7 md:h-12 w-auto"
            />
          </Link>
        </div>

        <button
          className="hover:bg-gray-100 p-2 rounded-full"
          onClick={onBackToWordPressPage}
        >
          <CloseIcon />
        </button>
      </div>

      {/* Content */}
      <Container
        maxWidth="md"
        className="z-20 relative justify-between flex flex-col flex-1"
      >
        <Stack spacing={5} className="items-center pt-12">
          <header className="text-center">
            {title && (
              <Typography
                variant="h4"
                className="mb-1 text-center justify-center text-black text-3xl font-bold font-['Eudoxus_Sans'] leading-9"
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                variant="body1"
                className="text-center justify-center text-zinc-600 text-base font-medium font-['Eudoxus_Sans'] leading-normal"
              >
                {subtitle}
              </Typography>
            )}
          </header>

          <main className="max-w-xl mx-auto w-full">{children}</main>
        </Stack>
        {footer ? (
          <footer className="mb-16">
            <div className="flex justify-center">{footer}</div>
          </footer>
        ) : null}
      </Container>

      {/* Background decorative elements */}
      <div className="absolute bottom-0 left-3 md:block hidden z-0">
        <BigCapLogo />
      </div>
    </div>
  );
}
